import React from 'react'
import styled from 'styled-components'
import {AiOutlineClose} from 'react-icons/ai'
import {darkTheme} from '../components/Themes'

const CustomModal = ({children, handleOnClick}) => {
  return (
    <ModalWrap >
        <Content>
          <div className="modalaction">
            <AiOutlineClose className='closeicon' size={30} color={darkTheme.accent} onClick={handleOnClick}/>
          </div>
            {children}
        </Content>
    </ModalWrap>
  )
}

export default CustomModal

const ModalWrap = styled.div`
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.3);
    height: 100vh;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 10;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${({theme}) => theme.body};
    width: 15rem;
    height: fit-content;
    border-radius: 5px;
    padding: 0.5rem;

    .modalaction {
      display: flex;
      justify-content: end;
      
      .closeicon {
        cursor: pointer;
        user-select:none;
      }
    }
`